import _ from 'lodash';
import React from 'react';
import Badge from '../components/Badge';
import Button from '../components/Button';
import { ModalTitle } from '../components/Modal';
import * as styles from './DiscardSectionChangesModalContent.module.scss';
import SidebarSectionIcon from './SidebarSectionIcon';
import type { Section } from './SidebarSectionsProvider';

function getDisplayAction(section: Section) {
  const lastAction = section.actions?.at(-1);
  if (lastAction === 'delete') return lastAction;
  const firstAction = section.actions?.at(0);
  if (firstAction === 'create') return firstAction;

  if (section.actions?.includes('update')) {
    return 'update';
  }

  if (section.actions?.includes('hide') || section.actions?.includes('show')) {
    return _.findLast(
      section.actions,
      (action) => action === 'hide' || action === 'show',
    );
  }

  return section.actions?.at(-1);
}

interface SectionRowProps {
  section: Section;
}

const SectionRow = ({ section }: SectionRowProps) => {
  const action = getDisplayAction(section);

  const color = (() => {
    if (action === 'delete') return 'red';
    if (action === 'create') return 'green';
    return 'blue';
  })();

  return (
    <div className={styles.sectionRow}>
      <SidebarSectionIcon section={section} />
      <span className={styles.sectionName}>{section.name}</span>
      <Badge color={color}>{action}</Badge>
    </div>
  );
};

interface DiscardSectionChangesModalContentProps {
  onConfirm: () => void;
  onBack: () => void;
  unsavedSections: Section[];
}

const DiscardSectionChangesModalContent = ({
  onConfirm,
  onBack,
  unsavedSections,
}: DiscardSectionChangesModalContentProps) => {
  return (
    <div className={styles.container}>
      <ModalTitle small noMargin>
        Discard your changes?
      </ModalTitle>
      <div className={styles.message}>
        The changes you made to sidebar sections have not been saved:
      </div>
      <div className={styles.sectionRowContainer}>
        {unsavedSections.map((section) => (
          <SectionRow section={section} key={section.id} />
        ))}
      </div>
      <div className={styles.footer}>
        <Button variant="secondary" onClick={onBack}>
          Back
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Discard
        </Button>
      </div>
    </div>
  );
};

export default DiscardSectionChangesModalContent;
